__turbopack_context__.v({
  "emergency": "zGloMq_emergency",
  "emergency__content": "zGloMq_emergency__content",
  "emergency__content-wrapper": "zGloMq_emergency__content-wrapper",
  "emergency__dismiss": "zGloMq_emergency__dismiss",
  "emergency__inner": "zGloMq_emergency__inner",
  "emergency__link": "zGloMq_emergency__link",
  "emergency__link-arrow": "zGloMq_emergency__link-arrow",
  "emergency__link-text": "zGloMq_emergency__link-text",
  "emergency__message": "zGloMq_emergency__message",
});
